<template>
  <div>
    <sysa-layout :pagetitle="$t('Partners Demonstrative')">
      <b-card>
        <b-row class="mt-2">
          <b-col md="8">
            <b-row>
              <b-col md="4">
                <brandSelectorUnique :modelValue="idBrand" @onChange="changeBrandFilter" />
              </b-col>
            </b-row>
          </b-col>
          <b-col md="4">
            <div class="table-buttons h-100">
              <button
                class="btn-sm btn btn-success"
                :disabled="!partnerLevels.length || $store.state.isLoading"
                @click="downloadXls"
              >
                {{ $t('XLS') }}
              </button>
              <button
                class="ml-1 btn btn-primary"
                :disabled="!idBrand || $store.state.isLoading"
                @click="getPartnerLevels"
              >
                {{ $t('Buscar') }}
              </button>
            </div>
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col>
            <h5>
              <span @click="filterN3" class="text-primary cursor-pointer">{{ $t('Nível 3') }}</span>
              <span class="font-lower text-secondary">/</span>
              <span
                @click="filterN2(null)"
                :class="`${n3Filter ? 'text-primary' : 'text-secondary'} cursor-pointer`"
                >{{ $t('Nível 2') }}</span
              >
              <span class="font-lower text-secondary">/</span>
              <span :class="`${n2Filter ? 'text-primary' : 'text-secondary'} cursor-pointer`">{{
                $t('Nível 1')
              }}</span>
            </h5>
          </b-col>
        </b-row>
        <!-- Nível 3 -->
        <b-row class="mt-3" v-if="!n3Filter">
          <b-col md="4" v-for="(pl, i) in groupedLevels" :key="i" class="mb-2">
            <partnerLevelCard :partnerLevel="pl" @onFilter="filterN2" />
          </b-col>
        </b-row>
        <!-- Nível 2 -->
        <b-row class="mt-3" v-if="n3Filter && !n2Filter">
          <b-col md="4" v-for="(pl, i) in groupedLevels2" :key="i" class="mb-2">
            <partnerLevelCard :partnerLevel="pl" @onFilter="filterN1" />
          </b-col>
        </b-row>
        <!-- Nível 1 -->
        <b-row class="mt-3" v-if="n2Filter">
          <b-col md="4" v-for="(pl, i) in groupedLevels1" :key="i" class="mb-2">
            <partnerLevelCard :partnerLevel="pl" @onFilter="() => {}" />
          </b-col>
        </b-row>
      </b-card>
    </sysa-layout>
  </div>
</template>

<script>
import partnerLevelCard from './partnerLevelCard';
import brandSelectorUnique from '@/components/selectors/brandSelectorUnique';
import { jsonToXlsx } from '@/utils/xlsExport/jsonToXlsx';
import moment from 'moment';

export default {
  components: { partnerLevelCard, brandSelectorUnique },
  data() {
    return {
      partnerLevels: [],
      n3Filter: null,
      n2Filter: null,
      idBrand: null
    };
  },
  methods: {
    changeBrandFilter(idBrand) {
      this.idBrand = idBrand;
    },
    getPartnerLevels() {
      this.$store.commit('SET_LOADING', true);

      this.$api
        .get('api/partnerLevel/all', { idBrand: this.idBrand })
        .then((res) => {
          this.$store.commit('SET_LOADING', false);
          this.partnerLevels = res.data;
        })
        .catch((err) => {
          this.$store.commit('SET_LOADING', false);
          console.log(err);
        });
    },
    filterN3() {
      this.n3Filter = null;
      this.n2Filter = null;
    },
    filterN2(plid) {
      if (plid) this.n3Filter = plid;
      this.n2Filter = null;
    },
    filterN1(plid) {
      this.n2Filter = plid;
    },
    getAffiliatesByN1() {
      return [];
    },
    downloadXls() {
      let ids = [];

      for (const pl of this.partnerLevels) {
        if (pl.partners.length) {
          ids = ids.concat(pl.partners);
        }
      }

      ids = Array.from(new Set(ids.filter((i) => i)));

      this.$store.commit('SET_LOADING', true);
      this.$api
        .get(`api/partner/all?partnerIds=${ids.join(',')}`)
        .then((res) => {
          this.$store.commit('SET_LOADING', false);
          let items = [];

          for (const pl of this.partnerLevels) {
            for (const p of pl.partners) {
              let partner = res.data.find((i) => i.id == p);

              if (p && partner?.name) {
                items.push({
                  partner: partner.name,
                  token: partner.token,
                  payment_type: partner?.payment_type || '',
                  level: partner.level,
                  partner_level: pl.name,
                  partner_level_id: pl.id,
                  percentage: this.$utils.formatPercentString(partner?.reward?.percentage || 0),
                  reward_deduction: partner.reward_deduction ? this.$t('Ativo') : this.$t('Inativo'),
                  parent: pl.id_parent_level
                });
              }
            }
          }

          jsonToXlsx({
            name: `${this.$t('Partners')} ${this.$t('Details')} - ${moment().format('DD-MM-YYYY HH:mm')}`,
            headers: [
              this.$t('Partner'),
              this.$t('Token'),
              this.$t('Payment Type'),
              this.$t('Level'),
              this.$t('Partner Level'),
              this.$t('Partner Level') + ' (id)',
              this.$t('Percentage'),
              this.$t('Reward Deduction'),
              this.$t('Parent Level')
            ],
            data: items
          });
        })
        .catch((err) => {
          console.log(err);
          this.$store.commit('SET_LOADING', false);
        });
    }
  },
  computed: {
    groupedLevels() {
      let grouped = [];

      let l3 = this.partnerLevels.filter((pl) => {
        return pl.level == 3;
      });

      for (const item of l3) {
        let l2 = this.partnerLevels.filter((pl) => {
          return pl.level == 2 && item.id == pl.id_parent_level;
        });

        for (const item2 of l2) {
          let l1 = this.partnerLevels.filter((pl) => {
            return pl.level == 1 && item2.id == pl.id_parent_level;
          });

          item2.lowers = l1;
        }

        grouped.push({
          ...item,
          lowers: l2
        });
      }

      return grouped;
    },
    groupedLevels2() {
      let grouped = [];

      let l2 = this.partnerLevels.filter((pl) => {
        return pl.level == 2 && pl.id_parent_level == this.n3Filter;
      });

      for (const item of l2) {
        let l1 = this.partnerLevels.filter((pl) => {
          return pl.level == 1 && item.id == pl.id_parent_level;
        });

        grouped.push({
          ...item,
          lowers: l1
        });
      }

      return grouped;
    },
    groupedLevels1() {
      let grouped = [];

      let l1 = this.partnerLevels.filter((pl) => {
        return pl.level == 1 && pl.id_parent_level == this.n2Filter;
      });

      for (const item of l1) {
        grouped.push({
          ...item,
          //affiliates down for this n1
          lowers: []
        });
      }

      return grouped;
    }
  }
};
</script>

<style></style>
